import { Text, VSpacer } from '@/components/DesignSystem';
import { ChurnStatusDetails, ChurnStatus } from '@shared/enums';
import { Box, Stack, useTheme } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { getChurnStatusColor } from '@/utilities/ChurnStatusColor';
import React from 'react';
import beta from '@/assets/icons/beta.svg';
import { removeWhiteSpace } from "@shared/utilities";

interface ChurnBannerProps {
  explanation?: string | null;
  status: ChurnStatus;
  testID?: string;
}

export const ChurnBanner: React.FC<ChurnBannerProps> = ({
  explanation,
  status,
  testID = 'churn-banner',
}) => {
  const theme = useTheme();

  if (!status || status === ChurnStatus.NoRisk) {
    return null;
  }

  const { background, color } = getChurnStatusColor(status, theme);
  const churnData = ChurnStatusDetails[status];
  const explanationText = explanation?.trim()
    ? removeWhiteSpace(explanation)
    : removeWhiteSpace(churnData.reason);

  return (
    <Box
      data-testid={testID}
      sx={{
        backgroundColor: background,
        color: color,
        borderRadius: '4px',
        padding: '16px',
        position: 'relative',
        width: '100%',
      }}
    >
      <Stack direction="row" spacing={1}>
        <Box>
          {status === ChurnStatus.High ? (
            <InfoIcon sx={{ fontSize: 20 }}/>
          ) : (
            <WarningIcon sx={{ fontSize: 20 }}/>
          )}
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Stack alignItems="center" direction="row" justifyContent="space-between">
            <Box sx={{
              fontSize: '14px',
              fontWeight: 500,
              letterSpacing: 0.1,
              lineHeight: '20px',
            }}>
              {churnData.label}
            </Box>
            <img
              alt="Beta"
              height="16"
              src={beta}
            />
          </Stack>
          <VSpacer size="3"/>
          <Box sx={{ fontSize: '14px', letterSpacing: 0.25, lineHeight: '20px' }}>
            <Text category="body-medium">{explanationText}</Text>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};
